import { render, staticRenderFns } from "./BankaBilgileriForm.vue?vue&type=template&id=08e1e153"
import script from "./BankaBilgileriForm.vue?vue&type=script&lang=ts"
export * from "./BankaBilgileriForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports